import Cookies from 'js-cookie';
import ConfigCmsApi from '../configs/ConfigCmsApi';

const options = () => ({ headers: { Authorization: Cookies.get('adminToken') } });

export default {
  list(target) {
    return ConfigCmsApi.get('/texts/revisions', { ...options(), params: { ...target, limit: 10 } });
  },
  create(target, label, requestId) {
    return ConfigCmsApi.post('/texts/revisions', { target, label, request_id: requestId }, options());
  },
  get(id) {
    return ConfigCmsApi.get(`/texts/revisions/${id}`, options());
  },
};
